

































import type { PropType } from '@vue/composition-api';
import { watch, onMounted, computed, defineComponent, ref } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { SigningHelper } from '../../../helpers/signing.helper';
import type { BankId } from '../../../types/bankid';
import { BankIdStep, HintCodePending } from '../../../types/enums/bankid-se';

export default defineComponent({
  props: {
    bankId: {
      type: Object as PropType<BankId>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const ssn = ref('');
    const startValidate = computed(() => ssn.value.length >= 10);
    const validSsn = computed(() => SigningHelper.validateSsn(ssn.value));
    const showInvalidSsnText = computed(() => !validSsn.value && startValidate.value);
    const isLoading = computed(() => props.bankId.step === BankIdStep.Polling);
    const descriptionText = computed(() =>
      props.bankId.hintCode === HintCodePending.userSign
        ? `${t('waiting-for-signature')}. `
        : t('start-your-bankid-app-or').toString()
    );

    const handleCancel = () => {
      emit('cancel', ssn.value);
    };

    const handleStartSSN = () => {
      emit('startSSN', ssn.value);
    };

    const setSsn = () => {
      if (props.bankId.ssn) {
        ssn.value = props.bankId.ssn;
      }
    };

    watch(
      () => props.bankId.ssn,
      () => {
        setSsn();
      }
    );

    onMounted(() => {
      setSsn();
    });

    return {
      ssn,
      startValidate,
      validSsn,
      showInvalidSsnText,
      isLoading,
      descriptionText,
      handleCancel,
      handleStartSSN,
      setSsn,
    };
  },
});
